module.exports = __webpack_public_path__ + "img/dir-marker.1011be77.png";